import { MemberTypes } from '../../models/ss-api/responses/login.response';
import { GlobalServices } from '../../services/global.service';

import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as $ from 'jquery';
window['jQuery'] = $;

import 'metismenu';
import 'jquery-slimscroll';
import { ssApiService } from 'app/services/ss-api.service';
import { MemberDesignerLicenseBasicsResponseArray } from 'app/models/ss-api/responses/member.designers.licenses.basics.response';
import { MemberAnnouncementArray } from 'app/models/ss-api/responses/member.announcement';
import { interval } from 'rxjs';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent implements OnInit, AfterViewInit {

    public UserType: string;

    devMenu: boolean = false;

    nonVizterraProduct: boolean;

    MyProducts: MemberDesignerLicenseBasicsResponseArray;

    MyAnnouncements: MemberAnnouncementArray;

    devAccounts: string[] = [
        'michael@structurestudios.com',
        'fausto@structurestudios.com',
        'fausto2@structurestudios.com'
    ];

    constructor(private api: ssApiService, private router: Router, public gb: GlobalServices) { }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    ngOnInit() {
        this.checkForDevMenu();
        this.CheckIfMemberHasNonVizterraProduct();
        this.CheckAnnouncements();
        //Every 60 seconds...
        interval(60000).subscribe(x => {
            this.CheckAnnouncements();
        });
    }

    AccountHolder(): string {

        return (this.gb.MemberType == MemberTypes.Member) ? 'Member' : 'Designer';

    }

    ngAfterViewInit(): void {


        (<any>$('#side-menu')).metisMenu();

        if ($('body').hasClass('fixed-sidebar')) {
            (<any>$('.sidebar-collapse')).slimscroll({
                height: '100%'
            });
        }
    }
    CheckAnnouncements(){
        console.log("ann", "now");
        const subscription = this.api.GetMemberAnnouncements().subscribe(res => {
            // this.MyProducts = res.Data.Licenses.filter(license => license.Status == 1);
            this.MyAnnouncements = res.Data;
        });
    }
    CheckIfMemberHasNonVizterraProduct() {
        let productFound = false;
        const subscription = this.api.MemberDesignersLicensesBasics().subscribe(res => {
            // this.MyProducts = res.Data.Licenses.filter(license => license.Status == 1);
            this.MyProducts = res.Data;

            this.MyProducts.forEach(function (product) {
                product.Keys.forEach(function (key) {
                    if (key && key.Product_ID != 9) {
                        productFound = true;
                    }
                });
            }, this);
            
            this.nonVizterraProduct = productFound;

        });

    } 


    checkForDevMenu() {

        this.devAccounts.forEach(x => {
            if (this.gb.Email && this.gb.Email.toLowerCase() == x)
                this.devMenu = true;
        });

    }

}
